<template>
  <f7-page name="oeb-ejercicios" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link back icon-f7="arrow_left"></f7-link>
        <div class="btn-info" @click.stop="togglePanelInfo" :class="{'btn-info-activo': panelInfoAbierto}"><span>i</span></div>
      </f7-nav-left>
      <f7-nav-title>OEB Producción por ejercicios</f7-nav-title>
      <f7-nav-right>
        <button class="navbar-btn navbar-btn-primary" @click="consultar(false, true)">Consultar</button>
        <info-icon dominio="oeb" clave="OEB_EjConsultar" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" @click.native.stop />
        <button class="navbar-btn" @click="guardarConsulta">Guardar</button>
        <info-icon dominio="oeb" clave="OEB_EjGuardarConsulta" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" @click.native.stop />
        <button class="navbar-btn" @click="cargarConsulta">Cargar</button>
        <info-icon dominio="oeb" clave="OEB_EjCargarConsulta" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" @click.native.stop />
        <span style="width:1px;height:16px;background:rgba(255,255,255,0.2);margin:0 4px"></span>
        <button class="navbar-btn navbar-btn-blue" @click="consultar(true, true)" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">Recalcular {{ anioActual }}</button>
        <info-icon dominio="oeb" clave="OEB_EjRecalcularAnio" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" @click.native.stop />
        <button class="navbar-btn" @click="consultar(true, false)" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">Recalcular todo</button>
        <info-icon dominio="oeb" clave="OEB_EjRecalcularTodo" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" @click.native.stop />
        <span style="width:1px;height:16px;background:rgba(255,255,255,0.2);margin:0 4px"></span>
        <f7-link @click="zoomOut" style="font-size:12px;color:#c8d3e5">−</f7-link>
        <span style="font-size:11px;color:white;min-width:35px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;color:#c8d3e5">+</f7-link>
        <f7-link @click="consultar(false, true)" icon-f7="arrow_2_circlepath" style="margin-left:6px;color:#c8d3e5"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · La tabla mezcla anos servidos de oeb_ejercicios_cache con anos recalculados en la peticion; la API publica el mas antiguo de todos. -->
    <div class="sello-datos-bar">
      <sello-datos estado="fecha" :fecha="calculadoEn" />
    </div>
    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="contenido-ej" :style="{ fontSize: (zoom * 0.12) + 'px' }">

      <!-- FILTROS + AÑOS en una barra -->
      <div class="filtros-bar">
        <span class="filtros-label">FILTROS:</span>
        <span class="filtro-fijo">Activo: Sí</span>
        <span class="filtro-fijo">≠ Cancelado</span>
        <span class="filtro-activo" style="background:#FFF3E0;color:#E65100">TPC: Sí</span>
        <template v-for="(valores, campo) in filtrosActivosResumen">
          <span v-if="valores && valores.length > 0" :key="campo" class="filtro-activo">
            {{ nombreFiltro(campo) }}: {{ valores.join(', ') }}
            <span class="filtro-x" @click="quitarFiltro(campo)">✕</span>
          </span>
        </template>
        <span class="filtro-add" @click="abrirPopupFiltros">+ Filtro</span>
        <info-icon dominio="oeb" clave="OEB_EjFiltros" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" />
        <span class="filtro-sep"></span>
        <span class="filtros-label">Años: <info-icon dominio="oeb" clave="OEB_EjSelectorAnios" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></span>
        <select v-model="selectorAnios" @change="cambiarSelectorAnios" class="select-anios">
          <option value="actual">Solo {{ anioActual }}</option>
          <option value="ultimos5">Últimos 5</option>
          <option value="ultimos10">Últimos 10</option>
          <option value="todos">Todos (2007-{{ anioActual }})</option>
        </select>
        <span class="filtro-sep"></span>
        <span class="cache-badge" v-if="aniosCacheados && aniosCacheados.length">Cache: {{ aniosCacheados[0] }}-{{ aniosCacheados[aniosCacheados.length-1] }} <info-icon dominio="oeb" clave="OEB_EjCache" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></span>
      </div>

      <!-- CONSULTAS GUARDADAS -->
      <div class="consultas-bar" v-if="consultasGuardadas.length">
        <span class="consultas-label">CONSULTAS: <info-icon dominio="oeb" clave="OEB_EjConsultasGuardadas" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></span>
        <span v-for="(c, idx) in consultasGuardadas" :key="c.id" class="consulta-pill"
          :class="{'consulta-activa': consultaActiva === c.id && !modoSeleccion, 'consulta-compartida': c.compartida, 'consulta-dragging': draggingConsulta === idx, 'consulta-seleccionada': consultasSeleccionadas.indexOf(c.id) > -1}"
          draggable="true"
          @dragstart="dragStartConsulta($event, idx)"
          @dragover.prevent
          @drop="dropConsulta($event, idx)"
          @dragend="draggingConsulta = null"
          @click="modoSeleccion ? toggleSeleccion(c.id) : aplicarConsulta(c)"
          @contextmenu.prevent="menuContextoConsulta($event, c)">
          <input type="checkbox" v-if="modoSeleccion" :checked="consultasSeleccionadas.indexOf(c.id) > -1" @click.stop="toggleSeleccion(c.id)" style="margin:0;width:12px;height:12px">
          {{ c.nombre }}{{ c.compartida ? ' ↗' : '' }}
          <span class="consulta-x" v-if="!modoSeleccion" @click.stop="borrarConsulta(c)">✕</span>
        </span>
        <span v-if="!modoSeleccion && consultasGuardadas.length > 1" class="btn-modo-compartir" @click="modoSeleccion = true">Compartir</span>
        <template v-if="modoSeleccion">
          <button v-if="consultasSeleccionadas.length > 0" class="btn-compartir-lote" @click="compartirEnLote">Compartir {{ consultasSeleccionadas.length }}</button>
          <span class="btn-modo-compartir" @click="modoSeleccion = false; consultasSeleccionadas = []">Cancelar</span>
        </template>
      </div>

      <!-- LOADING -->
      <f7-block v-if="cargando" class="text-align-center"><f7-preloader></f7-preloader></f7-block>

      <!-- TABLA -->
      <div class="tabla-ej-scroll" v-if="ejerciciosFiltrados.length && !cargando">
        <table class="tabla-ej">
          <thead>
            <tr>
              <th class="col-sticky col-anio">AÑO</th>
              <th v-for="m in nombresMes" :key="m" class="col-mes">{{ m }}</th>
              <th class="col-total">TOTAL <info-icon dominio="oeb" clave="OEB_TPC_SI" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></th>
              <!-- #35 · el periodo lo rotula la API (mesesComparables), no el reloj del navegador. -->
              <th class="col-total-comp" :title="tituloTotalComparable">TOTAL {{ periodoComparable }}</th>
              <th class="col-var">% VAR <info-icon dominio="oeb" clave="OEB_PctVariacion" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></th>
              <th class="col-var-comp" :title="tituloVarComparable">% VAR {{ periodoComparable }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ej in ejerciciosFiltrados" :key="ej.anio" :class="{'fila-actual': ej.anio === anioActual}">
              <td class="col-sticky col-anio"><strong>{{ ej.anio }}</strong></td>
              <td v-for="(val, idx) in ej.meses" :key="idx" class="col-mes">{{ val > 0 ? formatImporte(val) : '—' }}</td>
              <td class="col-total"><strong>{{ formatImporte(ej.total) }}</strong></td>
              <td class="col-total-comp">
                <strong v-if="ej.totalComparable != null">{{ formatImporte(ej.totalComparable) }}</strong>
                <span v-else>—</span>
              </td>
              <td class="col-var" :class="colorVar(ej.variacion)">
                <span v-if="ej.variacion != null">{{ ej.variacion >= 0 ? '+' : '' }}{{ ej.variacion }}%</span>
                <span v-else>—</span>
              </td>
              <td class="col-var-comp" :class="colorVar(ej.variacionComparable)">
                <span v-if="ej.variacionComparable != null">{{ ej.variacionComparable >= 0 ? '+' : '' }}{{ ej.variacionComparable }}%</span>
                <span v-else>—</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="fila-media">
              <td class="col-sticky col-anio"><strong>MEDIA</strong> <info-icon dominio="oeb" clave="OEB_MediaMensual" criticidad="CRITICO" pantalla="control-cifras-oeb-ejercicios" /></td>
              <td v-for="(val, idx) in media.meses" :key="'m-'+idx" class="col-mes">{{ val > 0 ? formatImporte(val) : '—' }}</td>
              <td class="col-total"><strong>{{ formatImporte(media.total) }}</strong></td>
              <td class="col-total-comp">
                <strong v-if="media.totalComparable != null">{{ formatImporte(media.totalComparable) }}</strong>
                <span v-else>—</span>
              </td>
              <td class="col-var">—</td>
              <!-- Una media de varios anos no tiene ano anterior contra el que compararse. -->
              <td class="col-var-comp">—</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- GRÁFICO -->
      <div class="grafico-zona" v-if="ejerciciosFiltrados.length && !cargando">
        <canvas ref="chartCanvas" style="width:100%;height:280px"></canvas>
      </div>

      <!-- SIN DATOS -->
      <f7-block v-if="!cargando && !ejercicios.length" class="text-align-center">
        <p>Pulse "Consultar" para cargar los datos</p>
      </f7-block>

      </div>
    </f7-page-content>

    <!-- POPUP FILTROS — carga bajo demanda -->
    <f7-popup :opened="popupFiltros" @popup:closed="popupFiltros = false" class="popup-filtros">
      <f7-page>
        <f7-navbar>
          <f7-nav-left><span></span></f7-nav-left>
          <f7-nav-title>{{ campoFiltroAbierto ? nombreFiltro(campoFiltroAbierto) : 'Filtros' }}</f7-nav-title>
          <f7-nav-right><f7-link popup-close icon-f7="xmark"></f7-link></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <!-- PASO 1: Lista de campos -->
          <div v-if="!campoFiltroAbierto">
            <div v-for="campo in camposFiltro" :key="campo" @click="abrirCampoFiltro(campo)"
              style="display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid #eee;cursor:pointer">
              <span style="font-size:14px;font-weight:500;color:#1a2744">{{ nombreFiltro(campo) }}</span>
              <span v-if="filtrosTemp[campo] && filtrosTemp[campo].length"
                style="font-size:11px;background:#FAEEDA;color:#633806;padding:2px 8px;border-radius:10px;font-weight:600">
                {{ filtrosTemp[campo].length }} sel.
              </span>
              <f7-icon v-else f7="chevron_right" style="font-size:14px;color:#ccc"></f7-icon>
            </div>
            <div style="padding:16px">
              <f7-button fill @click="aplicarFiltros">Aplicar filtros</f7-button>
            </div>
          </div>
          <!-- PASO 2: Valores del campo seleccionado -->
          <div v-else>
            <div style="padding:8px 16px 4px;display:flex;align-items:center;gap:8px">
              <f7-link @click="campoFiltroAbierto = null" icon-f7="arrow_left" style="font-size:14px"></f7-link>
              <span style="font-size:13px;font-weight:600;color:#1a2744;flex:1">{{ nombreFiltro(campoFiltroAbierto) }}</span>
              <span v-if="filtrosTemp[campoFiltroAbierto] && filtrosTemp[campoFiltroAbierto].length"
                style="font-size:9px;background:#FAEEDA;color:#633806;padding:1px 6px;border-radius:8px">
                {{ filtrosTemp[campoFiltroAbierto].length }}
              </span>
              <!-- #43 · "Todos" no se ofrece en los campos que se buscan escribiendo: ahí "todos"
                   sería el maestro entero, y marcar 90.000 códigos no es lo que nadie quiere. -->
              <button v-if="!esBusquedaServidor(campoFiltroAbierto)" style="font-size:9px;padding:1px 6px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white" @click="seleccionarTodosFiltro(campoFiltroAbierto)">Todos</button>
              <button style="font-size:9px;padding:1px 6px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white" @click="deseleccionarTodosFiltro(campoFiltroAbierto)">Ninguno</button>
            </div>
            <div style="padding:4px 16px 8px">
              <input type="text" v-model="busquedaFiltro[campoFiltroAbierto]" :placeholder="placeholderFiltro(campoFiltroAbierto)"
                @input="alEscribirEnFiltro(campoFiltroAbierto)"
                style="width:100%;padding:6px 10px;border:1px solid #ddd;border-radius:4px;font-size:12px;box-sizing:border-box">
            </div>
            <!-- #43 · Cliente no se descarga: son del orden de 90.000 y se busca contra el
                 servidor. Lo ya elegido se pinta arriba y siempre, case o no con lo escrito, para
                 poder quitarlo sin tener que adivinar qué texto lo trajo. -->
            <div v-if="esBusquedaServidor(campoFiltroAbierto)" style="padding:0 16px">
              <div v-if="filtrosTemp[campoFiltroAbierto] && filtrosTemp[campoFiltroAbierto].length"
                style="border-bottom:1px solid #eee;padding-bottom:6px;margin-bottom:6px">
                <label v-for="v in filtrosTemp[campoFiltroAbierto]" :key="'sel-' + v"
                  style="display:flex;align-items:center;gap:6px;font-size:12px;padding:4px 0;cursor:pointer">
                  <input type="checkbox" :value="v" v-model="filtrosTemp[campoFiltroAbierto]" style="margin:0;width:14px;height:14px"> {{ etiquetaValorServidor(v) }}
                </label>
              </div>
              <div v-if="buscandoEnServidor" style="text-align:center;padding:20px"><f7-preloader></f7-preloader></div>
              <template v-else>
                <!-- #43 · Si no se ha podido preguntar al servidor, el campo lo dice. Decir "ningún
                     cliente coincide" sería dar por buena una respuesta que nunca llegó. -->
                <template v-if="errorBusquedaServidor">
                  <p style="font-size:11px;color:#B71C1C;padding:8px 0;margin:0">
                    No se ha podido cargar la lista de clientes.
                  </p>
                  <button @click="reintentarBusquedaServidor"
                    style="font-size:11px;padding:4px 8px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white;margin-bottom:8px">
                    Reintentar
                  </button>
                  <button v-if="pareceCodigoCliente" @click="usarTextoComoCodigo"
                    style="font-size:11px;padding:4px 8px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white;margin:0 0 8px 6px">
                    Filtrar por el código «{{ textoBusquedaActual }}» de todas formas
                  </button>
                </template>
                <p v-else-if="textoBusquedaCorto" style="font-size:11px;color:#7c8db0;padding:8px 0;margin:0">
                  Escriba al menos {{ minimoBusqueda }} letras del nombre o del código para buscar.
                </p>
                <!-- #43 · Un cliente dado de baja del maestro puede seguir teniendo trabajo en el
                     reparto, y con la lista de antes aún se le podía elegir. Escribiendo su código
                     exacto se le sigue pudiendo filtrar sin volver a recorrer el reparto. -->
                <template v-else-if="!resultadosSinSeleccionar.length">
                  <p style="font-size:11px;color:#7c8db0;padding:8px 0;margin:0">
                    Ningún cliente coincide con lo escrito.
                  </p>
                  <button v-if="pareceCodigoCliente" @click="usarTextoComoCodigo"
                    style="font-size:11px;padding:4px 8px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white;margin-bottom:8px">
                    Filtrar por el código «{{ textoBusquedaActual }}» de todas formas
                  </button>
                </template>
                <div style="max-height:340px;overflow-y:auto">
                  <label v-for="c in resultadosSinSeleccionar" :key="c.codigo"
                    style="display:flex;align-items:center;gap:6px;font-size:12px;padding:4px 0;cursor:pointer">
                    <input type="checkbox" :value="c.codigo" v-model="filtrosTemp[campoFiltroAbierto]" style="margin:0;width:14px;height:14px"> {{ etiquetaValorServidor(c.codigo) }}
                  </label>
                </div>
              </template>
            </div>
            <div v-else-if="cargandoFiltro" style="text-align:center;padding:20px"><f7-preloader></f7-preloader></div>
            <div v-else style="padding:0 16px;max-height:400px;overflow-y:auto">
              <!-- #43 · Un campo cuya lista no ha podido cargarse lo dice aquí y deja reintentarlo.
                   En blanco se confundía con un campo sin valores que elegir. -->
              <template v-if="errorFiltro[campoFiltroAbierto]">
                <p style="font-size:11px;color:#B71C1C;padding:8px 0;margin:0">
                  No se ha podido cargar la lista de {{ nombreFiltro(campoFiltroAbierto) }}.
                </p>
                <button @click="reintentarCampoFiltro(campoFiltroAbierto)"
                  style="font-size:11px;padding:4px 8px;border:1px solid #ddd;border-radius:3px;cursor:pointer;background:white;margin-bottom:8px">
                  Reintentar
                </button>
              </template>
              <p v-else-if="!valoresCampo(campoFiltroAbierto).length" style="font-size:11px;color:#7c8db0;padding:8px 0;margin:0">
                Este campo no tiene ningún valor que elegir.
              </p>
              <p v-else-if="!valoresFiltrados(campoFiltroAbierto).length" style="font-size:11px;color:#7c8db0;padding:8px 0;margin:0">
                Ningún valor coincide con lo escrito.
              </p>
              <label v-for="v in valoresFiltrados(campoFiltroAbierto)" :key="v"
                style="display:flex;align-items:center;gap:6px;font-size:12px;padding:4px 0;cursor:pointer">
                <input type="checkbox" :value="v" v-model="filtrosTemp[campoFiltroAbierto]" style="margin:0;width:14px;height:14px"> {{ v }}
              </label>
            </div>
            <div style="padding:12px 16px">
              <f7-button fill @click="campoFiltroAbierto = null">Volver a campos</f7-button>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>

    <!-- MENÚ CONTEXTUAL -->
    <div v-if="menuConsulta" class="menu-contexto" :style="{ top: menuConsultaPos.y + 'px', left: menuConsultaPos.x + 'px' }" @mouseleave="menuConsulta = null">
      <div class="menu-contexto-item" @click="editarFiltrosConsulta(menuConsulta)">Editar filtros y consultar</div>
      <div class="menu-contexto-item" @click="compartirConsulta(menuConsulta)">Compartir</div>
      <div class="menu-contexto-item" @click="renombrarConsulta(menuConsulta)">Renombrar</div>
      <div class="menu-contexto-sep"></div>
      <div class="menu-contexto-item menu-contexto-danger" @click="borrarConsulta(menuConsulta); menuConsulta = null">Eliminar</div>
    </div>

    <!-- POPUP GUÍA DE USO (estilo Info Oferta) -->
    <f7-popup :opened="panelInfoAbierto" @popup:close="fullscreen = false; panelInfoAbierto = false" class="ct-popup" :style="fullscreen ? '--f7-popup-tablet-width:95vw;--f7-popup-tablet-height:95vh' : ''">
      <f7-page :page-content="false">
        <f7-navbar title="Guía de uso" style="display:none"></f7-navbar>
        <div class="ct-hdr" style="background:linear-gradient(135deg,#0F6E56,#27ae80)">
          <div class="ct-hdr-top">
            <div class="ct-hdr-left">
              <span class="ct-hdr-ico">📖</span>
              <div>
                <div class="ct-hdr-title">Guía de uso</div>
                <div class="ct-hdr-sub">OEB PRODUCCIÓN</div>
              </div>
            </div>
            <div class="ct-hdr-right">
              <span class="ct-hdr-badge">{{ instruccionesFiltradas.length }} instrucciones</span>
              <button class="ct-hdr-add" @click="nuevaInstruccion">+</button>
              <button class="ct-hdr-close" @click="fullscreen = !fullscreen">{{ fullscreen ? '⇖' : '⛶' }}</button>
              <button class="ct-hdr-close" @click="fullscreen = false; panelInfoAbierto = false">✕</button>
            </div>
          </div>
          <div class="ct-search-wrap">
            <span class="ct-search-ico">🔍</span>
            <input class="ct-search" type="text" placeholder="Buscar instrucciones..." v-model="busquedaInstrucciones">
            <button v-if="busquedaInstrucciones" class="ct-search-x" @click="busquedaInstrucciones = ''">✕</button>
          </div>
        </div>
        <f7-page-content class="ct-body">
          <div v-if="instruccionesFiltradas.length" class="ct-counter">{{ instruccionesFiltradas.length }} instrucciones</div>
          <div v-if="!instruccionesFiltradas.length" class="ct-empty">
            <span style="font-size:32px;opacity:.3">📖</span>
            <p>Sin instrucciones. Pulsa + para crear la primera.</p>
          </div>
          <div v-for="(inst, idx) in instruccionesFiltradas" :key="inst.id"
            class="ct-card" style="border-left-color:#0F6E56"
            draggable="true" @dragstart="dragStartInst($event, idx)" @dragover.prevent @drop="dropInst($event, idx)">
            <div class="ct-card-hdr" @click="expandedInst === inst.id ? expandedInst = null : expandedInst = inst.id">
              <span class="ct-card-num" style="background:#0F6E56">{{ idx + 1 }}</span>
              <div class="ct-card-title-area">
                <div class="ct-card-title">{{ inst.titulo }}</div>
              </div>
              <span class="ct-card-chev">{{ expandedInst === inst.id ? '▲' : '▼' }}</span>
            </div>
            <div v-if="expandedInst === inst.id" class="ct-card-body">
              <template v-if="inst._editando">
                <div class="ct-form-field"><label>Título</label><input type="text" v-model="inst.titulo"></div>
                <div class="ct-form-field"><label>Contenido</label><textarea v-model="inst.texto" rows="4"></textarea></div>
                <div class="ct-form-btns">
                  <button class="ct-fbtn ct-fbtn-ok" @click="guardarInstruccion(inst)">Guardar</button>
                  <button class="ct-fbtn ct-fbtn-cancel" @click="inst._editando = false">Cancelar</button>
                </div>
              </template>
              <template v-else>
                <div class="ct-card-content">{{ inst.texto }}</div>
                <div class="ct-card-actions">
                  <button @click.stop="editarInstruccion(inst)">✏️ Editar</button>
                  <button @click.stop="eliminarInstruccion(inst)">🗑️ Eliminar</button>
                </div>
              </template>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>
  </f7-page>
</template>
<style scoped>
/* Navbar buttons */
.navbar-btn { font-size:10px;padding:4px 10px;background:rgba(255,255,255,0.15);color:#c8d3e5;border:0.5px solid rgba(255,255,255,0.25);border-radius:4px;cursor:pointer;font-weight:500; }
.navbar-btn:hover { background:rgba(255,255,255,0.25); }
.navbar-btn-primary { background:#0F6E56 !important;color:white !important;border-color:#0F6E56 !important;font-weight:600; }
.navbar-btn-primary:hover { background:#0a4f42 !important; }
.navbar-btn-blue { background:#185FA5 !important;color:white !important;border-color:#185FA5 !important; }
.navbar-btn-blue:hover { background:#124d8a !important; }

/* Filtros bar */
.filtros-bar { display:flex;gap:0.5em;align-items:center;flex-wrap:wrap;padding:0.5em 1em;border-bottom:0.5px solid #e8edf3; }
.filtros-label { font-size:0.75em;color:#7c8db0;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;white-space:nowrap; }
.filtro-fijo { background:#E6F1FB;color:#0C447C;font-size:0.8em;padding:0.15em 0.6em;border-radius:0.8em;font-weight:500;white-space:nowrap; }
.filtro-activo { background:#FAEEDA;color:#633806;font-size:0.8em;padding:0.15em 0.6em;border-radius:0.8em;font-weight:500;white-space:nowrap;display:flex;align-items:center;gap:0.3em; }
.filtro-x { cursor:pointer;font-size:0.85em;opacity:0.6; }
.filtro-x:hover { opacity:1; }
.filtro-add { font-size:0.8em;color:#185FA5;cursor:pointer;font-weight:500; }
.filtro-sep { width:1px;height:1.2em;background:#dde3ed;margin:0 0.3em; }
.select-anios { font-size:0.8em;padding:0.15em 0.4em;border:1px solid #ddd;border-radius:0.3em;height:1.8em;min-width:8em;background:white; }
.cache-badge { font-size:0.7em;background:#D5F5E3;color:#0E6251;padding:0.1em 0.5em;border-radius:0.6em;white-space:nowrap; }
.btn-mini { font-size:0.7em;padding:0.15em 0.5em;border:0.5px solid #dde3ed;border-radius:0.25em;cursor:pointer;background:white;color:#7c8db0;white-space:nowrap; }
.btn-mini:hover { background:#f0f2f5; }

/* Consultas bar */
.consultas-bar { display:flex;gap:0.3em;align-items:center;flex-wrap:wrap;padding:0.3em 1em;border-bottom:0.5px solid #e8edf3; }
.consultas-label { font-size:0.75em;color:#7c8db0;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;white-space:nowrap; }
.consulta-pill { font-size:0.8em;padding:0.15em 0.6em;border-radius:0.8em;cursor:pointer;border:0.5px solid #dde3ed;background:white;display:flex;align-items:center;gap:0.3em;white-space:nowrap; }
.consulta-pill:hover { background:#f0f2f5; }
.consulta-activa { border-color:#185FA5;background:#E6F1FB;color:#0C447C;font-weight:500; }
.consulta-compartida { background:#EAF3DE;color:#27500A;border-color:#C0DD97; }
.consulta-x { font-size:0.75em;color:#B71C1C;cursor:pointer;opacity:0.5; }
.consulta-x:hover { opacity:1; }
.consulta-dragging { opacity:0.4; }
.consulta-pill[draggable="true"] { cursor:grab; }
.consulta-pill[draggable="true"]:active { cursor:grabbing; }
.consulta-seleccionada { outline:2px solid #185FA5;outline-offset:1px; }
.btn-compartir-lote { font-size:0.75em;padding:0.2em 0.6em;background:#185FA5;color:white;border:none;border-radius:0.3em;cursor:pointer;font-weight:500; }
.btn-modo-compartir { font-size:0.75em;color:#185FA5;cursor:pointer;font-weight:500;padding:0.15em 0.5em; }
.menu-contexto { position:fixed;background:white;border:0.5px solid #dde3ed;border-radius:8px;box-shadow:0 4px 16px rgba(0,0,0,0.12);padding:4px 0;z-index:9999;min-width:180px; }
.menu-contexto-item { padding:8px 16px;font-size:12px;cursor:pointer;color:#2d3748; }
.menu-contexto-item:hover { background:#f5f7fa; }
.menu-contexto-danger { color:#B71C1C !important; }
.menu-contexto-danger:hover { background:#FCEBEB !important; }
.menu-contexto-sep { height:1px;background:#e8edf3;margin:4px 0; }
.popup-filtros { --f7-popup-tablet-width:500px; }

/* Botón info */
.btn-info { width:24px;height:24px;border-radius:50%;background:rgba(255,255,255,0.15);display:flex;align-items:center;justify-content:center;cursor:pointer;border:1.5px solid #5DCAA5; }
.btn-info span { color:#5DCAA5;font-size:13px;font-weight:500;font-style:italic; }
.btn-info-activo { background:#5DCAA5 !important; }
.btn-info-activo span { color:#1a2744 !important; }

/* Popup guía (estilo Info Oferta de tarifas) */
.ct-popup { --f7-popup-tablet-width:700px; }
.ct-hdr { padding:14px 16px 12px;flex-shrink:0; }
.ct-hdr-top { display:flex;justify-content:space-between;align-items:center;margin-bottom:12px; }
.ct-hdr-left { display:flex;align-items:center;gap:10px; }
.ct-hdr-ico { font-size:24px; }
.ct-hdr-title { font-size:16px;font-weight:800;color:#fff;letter-spacing:.02em; }
.ct-hdr-sub { font-size:10px;color:rgba(255,255,255,.6);margin-top:1px; }
.ct-hdr-right { display:flex;align-items:center;gap:6px; }
.ct-hdr-badge { background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff; }
.ct-hdr-add,.ct-hdr-close { width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center; }
.ct-hdr-add:hover,.ct-hdr-close:hover { background:rgba(255,255,255,.25); }
.ct-search-wrap { position:relative;display:flex;align-items:center; }
.ct-search-ico { position:absolute;left:10px;font-size:13px; }
.ct-search { width:100%;padding:9px 32px;border:none;border-radius:8px;font-size:13px;background:rgba(255,255,255,.9);color:#1e293b;outline:none;box-shadow:0 2px 8px rgba(0,0,0,.1); }
.ct-search:focus { background:#fff;box-shadow:0 2px 12px rgba(0,0,0,.15); }
.ct-search-x { position:absolute;right:8px;background:none;border:none;color:#94a3b8;font-size:12px;cursor:pointer;padding:4px; }
.ct-body { background:linear-gradient(180deg,#f8fafc,#f0f2f5);padding:10px 14px !important; }
.ct-counter { font-size:11px;color:#64748b;font-weight:600;padding:4px 2px 8px;letter-spacing:.02em; }
.ct-empty { text-align:center;padding:40px 20px;display:flex;flex-direction:column;align-items:center;gap:8px;color:#94a3b8;font-size:12px; }
.ct-card { background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.05);overflow:hidden;cursor:grab; }
.ct-card:hover { box-shadow:0 3px 10px rgba(0,0,0,.08); }
.ct-card-hdr { display:flex;align-items:center;gap:10px;padding:10px 12px;cursor:pointer; }
.ct-card-num { width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;color:#fff;flex-shrink:0; }
.ct-card-title-area { flex:1;min-width:0; }
.ct-card-title { font-size:13px;font-weight:600;color:#1e293b;line-height:1.4; }
.ct-card-chev { font-size:10px;color:#94a3b8;flex-shrink:0; }
.ct-card-body { padding:0 12px 12px;border-top:1px solid #f1f5f9; }
.ct-card-content { font-size:12.5px;line-height:1.6;color:#334155;padding:10px 4px; }
.ct-card-actions { display:flex;gap:4px;padding-top:8px;border-top:1px solid #f1f5f9; }
.ct-card-actions button { background:none;border:1px solid #e2e8f0;border-radius:6px;padding:4px 10px;font-size:10px;cursor:pointer;color:#475569; }
.ct-card-actions button:hover { background:#f1f5f9;border-color:#94a3b8; }
.ct-form-field { display:flex;flex-direction:column;gap:3px;margin-bottom:8px; }
.ct-form-field label { font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.04em; }
.ct-form-field input,.ct-form-field textarea { padding:8px 10px;border:1.5px solid #d1d9e0;border-radius:6px;font-size:12px;font-family:inherit;color:#1e293b;outline:none;resize:vertical; }
.ct-form-field input:focus,.ct-form-field textarea:focus { border-color:#0F6E56; }
.ct-form-btns { display:flex;gap:6px; }
.ct-fbtn { padding:7px 16px;border:none;border-radius:6px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit; }
.ct-fbtn-ok { background:#0F6E56;color:#fff; }
.ct-fbtn-ok:hover { background:#0a4f42; }
.ct-fbtn-cancel { background:#f1f5f9;color:#475569;border:1px solid #e2e8f0; }
.ct-fbtn-cancel:hover { background:#e2e8f0; }

/* Tabla */
.tabla-ej-scroll { overflow-x:auto;-webkit-overflow-scrolling:touch;border:1px solid #dde3ed;border-radius:0.67em;margin:0 0.67em;box-shadow:0 1px 6px rgba(0,0,0,0.04);background:white; }
.tabla-ej { border-collapse:collapse;font-size:0.92em;white-space:nowrap;width:100%; }
.tabla-ej thead th { background:#1a2744;color:#c8d3e5;padding:0.67em 0.5em;font-weight:600;font-size:0.83em;text-transform:uppercase;letter-spacing:0.04em;text-align:right; }
.tabla-ej thead th.col-anio { text-align:left;color:white; }
.tabla-ej tbody td { padding:0.42em 0.5em;border-bottom:1px solid #eef0f5;text-align:right;color:#2d3748; }
.tabla-ej tbody tr:nth-child(even) { background:#fafbfd; }
.tabla-ej tbody tr:hover { background:#eef2f9 !important; }
.fila-actual { background:#E8F5E9 !important; }
.fila-actual:hover { background:#C8E6C9 !important; }
.col-sticky { position:sticky;left:0;background:white;z-index:1;box-shadow:2px 0 8px rgba(0,0,0,0.06); }
thead .col-sticky { background:#1a2744;z-index:3; }
.fila-media .col-sticky { background:#eef1f7; }
.fila-actual .col-sticky { background:#E8F5E9; }
.col-anio { text-align:left !important;min-width:4em;font-weight:700;color:#1a2744; }
.col-mes { min-width:5.5em; }
.col-total { min-width:6.5em;font-weight:700;border-left:2px solid #c8d0de !important; }
thead .col-total { border-left:2px solid #3d5278 !important; }
.col-var { min-width:4.5em;font-weight:600; }
/* #35 · las dos columnas comparables van pegadas a la suya, sin el separador grueso de TOTAL:
   la cabecera es mas larga («TOTAL ENE-AGO»), asi que piden algo mas de ancho. */
.col-total-comp { min-width:7.5em;font-weight:700; }
.col-var-comp { min-width:6.5em;font-weight:600; }
.var-positivo { color:#0E6251 !important; }
.var-negativo { color:#B71C1C !important; }
.fila-media td { background:#eef1f7;font-weight:700;padding:0.58em 0.5em;border-top:2px solid #c8d0de;color:#1a2744;text-align:right; }
.grafico-zona { margin:1em 0.67em;padding:1em;background:white;border:1px solid #dde3ed;border-radius:0.67em;box-shadow:0 1px 6px rgba(0,0,0,0.04); }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; display: flex; flex-wrap: wrap; gap: 8px; }
</style>
<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import InfoIcon from '../../components/InfoIcon.vue';
import SelloDatos from '../../components/SelloDatos.vue';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

// #43 · Qué campos tiene la ventana de Filtros no depende de los datos: es la misma lista fija que
// devuelve la API. Se conoce aquí para que la ventana los enseñe siempre, también cuando el
// servidor no contesta; si no, al fallar esa petición la ventana se abría vacía, sin un solo campo
// y sin decir por qué. La respuesta del servidor, cuando llega, manda y sustituye a esta.
var CAMPOS_FILTRO_POR_DEFECTO = [
  'materia', 'provincia', 'usuario', 'servicio', 'cliente',
  'estadoPedido', 'calificacion', 'estadoLinea', 'esde2as', 'esn1a'
];

export default {
  components: { InfoIcon, SelloDatos },
  data: function() {
    var anioActual = new Date().getFullYear();
    var anios = [];
    for (var a = 2007; a <= anioActual; a++) anios.push(a);
    return {
      zoom: 100, cargando: false,
      // #42 · Numero de la ultima peticion pedida, para descartar las respuestas que llegan tarde.
      peticionEnCurso: 0,
      ejercicios: [], media: { meses: [], total: 0 },
      mesesComparables: 0,
      aniosCacheados: [],
      calculadoEn: null,
      filtrosActivos: {},
      filtrosTemp: {},
      camposFiltro: CAMPOS_FILTRO_POR_DEFECTO.slice(),
      valoresCache: {},
      busquedaFiltro: {},
      campoFiltroAbierto: null,
      cargandoFiltro: false,
      popupFiltros: false,
      // #43 · Por campo, el motivo de que su lista no esté. Se pinta dentro del campo: una lista
      // que no se puede cargar tiene que decirlo ahí, no quedarse en blanco como si no hubiera
      // valores que elegir.
      errorFiltro: {},
      errorBusquedaServidor: false,
      // #43 · Campos que no se descargan como lista y se buscan escribiendo contra el servidor.
      // Arranca con el que es hoy para que la ventana se comporte igual aunque la precarga
      // todavía no haya contestado; la respuesta del servidor manda y lo sobrescribe.
      camposBusquedaServidor: ['cliente'],
      minimoBusqueda: 2,
      resultadosBusqueda: [],
      buscandoEnServidor: false,
      nombresCliente: {},
      busquedaServidorTimer: null,
      busquedaServidorSecuencia: 0,
      // Promesa de la precarga en vuelo: los campos la esperan en vez de pedirse por su cuenta.
      precargaPromesa: null,
      // Si la precarga falló, los campos de esta apertura van directos al respaldo sin volver a
      // esperarla; se reintenta al abrir la ventana otra vez.
      precargaFallida: false,
      secuenciaCampoFiltro: 0,
      consultasGuardadas: [],
      chartInstance: null,
      anioActual: anioActual,
      aniosDisponibles: anios,
      aniosSeleccionados: [anioActual],
      selectorAnios: 'actual',
      consultaActiva: null,
      consultaEditando: null,
      draggingConsulta: null,
      modoSeleccion: false,
      consultasSeleccionadas: [],
      menuConsulta: null,
      menuConsultaPos: { x: 0, y: 0 },
      panelInfoAbierto: false,
      fullscreen: false,
      instrucciones: [],
      draggingInst: null,
      expandedInst: null,
      busquedaInstrucciones: '',
      nombresMes: ['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC'],
      nombresMap: { materia:'Materia', provincia:'Provincia', usuario:'Usuario', servicio:'Servicio', cliente:'Cliente', estadoPedido:'Est.Pedido', estadoLinea:'Est.Línea', calificacion:'Calificación', esde2as:'Es de 2as', esn1a:'Es N.1ª' }
    };
  },
  computed: {
    ejerciciosFiltrados: function() {
      var sel = this.aniosSeleccionados;
      return this.ejercicios.filter(function(ej) { return sel.indexOf(ej.anio) > -1; });
    },
    // #35 · La cabecera de las columnas comparables dice qué periodo suman y cambia sola con el
    // mes, porque sale de `mesesComparables` de la respuesta. En enero la ventana está vacía.
    periodoComparable: function() {
      if (!this.mesesComparables) return '—';
      if (this.mesesComparables === 1) return 'ENE';
      return 'ENE-' + this.nombresMes[this.mesesComparables - 1];
    },
    tituloTotalComparable: function() {
      if (!this.mesesComparables) return 'En enero no hay ningún mes cerrado: la ventana comparable está vacía.';
      return 'Suma de ' + this.periodoComparable + ', la misma ventana en todas las filas. El mes en curso no entra porque está a medias.';
    },
    tituloVarComparable: function() {
      if (!this.mesesComparables) return 'En enero no hay ningún mes cerrado: la ventana comparable está vacía.';
      return 'Variación de ' + this.periodoComparable + ' contra el mismo periodo del año anterior.';
    },
    instruccionesFiltradas: function() {
      var q = (this.busquedaInstrucciones || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) {
        return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1;
      });
    },
    // #43 · Con menos de dos letras la búsqueda casaría con casi todo el maestro y no ayudaría a
    // nadie a encontrar su cliente, así que ni se pregunta.
    textoBusquedaCorto: function() {
      if (!this.campoFiltroAbierto) return true;
      return (this.busquedaFiltro[this.campoFiltroAbierto] || '').trim().length < this.minimoBusqueda;
    },
    textoBusquedaActual: function() {
      if (!this.campoFiltroAbierto) return '';
      return (this.busquedaFiltro[this.campoFiltroAbierto] || '').trim();
    },
    // #43 · Solo se ofrece usar lo escrito como código cuando tiene pinta de serlo —los de SIMECAL
    // son del estilo C000123M: sin espacios y con dígitos—, para no proponerlo cada vez que una
    // búsqueda por nombre no encuentra nada.
    pareceCodigoCliente: function() {
      var texto = this.textoBusquedaActual;
      return /^[A-Za-z0-9._\-/]{3,}$/.test(texto) && /[0-9]/.test(texto);
    },
    // Lo ya elegido se pinta aparte y arriba; aquí solo va lo que la búsqueda añade.
    resultadosSinSeleccionar: function() {
      var elegidos = this.filtrosTemp[this.campoFiltroAbierto] || [];
      return this.resultadosBusqueda.filter(function(c) { return elegidos.indexOf(c.codigo) === -1; });
    },
    filtrosActivosResumen: function() {
      var res = {};
      var keys = Object.keys(this.filtrosActivos);
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (this.filtrosActivos[k] && this.filtrosActivos[k].length) res[k] = this.filtrosActivos[k];
      }
      return res;
    }
  },
  watch: {
    ejerciciosFiltrados: function() { var self = this; self.$nextTick(function() { self.renderChart(); }); }
  },
  methods: {
    onPageInit: function() {
      this.cargarCamposFiltro();
      this.cargarConsultasGuardadas();
      this.cargarInstrucciones();
      this.consultar(false, true);
    },
    zoomIn: function() { this.zoom = Math.min(150, this.zoom + 5); },
    zoomOut: function() { this.zoom = Math.max(40, this.zoom - 5); },
    nombreFiltro: function(campo) { return this.nombresMap[campo] || campo; },
    valoresFiltrados: function(campo) {
      var busqueda = (this.busquedaFiltro[campo] || '').toLowerCase();
      var valores = this.valoresCache[campo] || [];
      if (!busqueda) return valores;
      return valores.filter(function(v) {
        return v.toLowerCase().indexOf(busqueda) !== -1;
      });
    },
    // Los campos que ya hay puestos solo se sustituyen si el servidor trae algo: ni un error ni una
    // respuesta vacía pueden dejar la ventana de Filtros sin un campo que ofrecer (#43).
    cargarCamposFiltro: function() {
      var self = this;
      Oeb.getEjerciciosCamposFiltro().then(function(res) {
        var campos = unwrapDto(res) || [];
        if (campos.length) self.camposFiltro = campos;
      }).catch(function() {});
    },
    /** Los valores descargados de un campo, sin el filtrado por lo escrito en el buscador. */
    valoresCampo: function(campo) {
      return this.valoresCache[campo] || [];
    },
    esBusquedaServidor: function(campo) {
      return campo != null && this.camposBusquedaServidor.indexOf(campo) > -1;
    },
    placeholderFiltro: function(campo) {
      return this.esBusquedaServidor(campo) ? 'Escriba parte del nombre o el código...' : 'Buscar...';
    },
    // Un código de cliente no lo reconoce nadie, así que se enseña con su nombre al lado. Si el
    // nombre no se ha podido resolver —código que ya no está en el maestro— se deja el código
    // solo: quitarlo de la lista lo dejaría seleccionado en silencio y sin forma de desmarcarlo.
    etiquetaValorServidor: function(codigo) {
      var nombre = this.nombresCliente[codigo];
      return nombre ? codigo + ' — ' + nombre : codigo;
    },
    /**
     * Trae de una vez las listas de todos los campos que sí se descargan (#43). Antes cada campo
     * se pedía al pincharlo, y cada petición volvía a recorrer el reparto entero: ocho recorridos
     * en serie por pasar la ventana. Se lanza al abrirla, así que cuando se pincha un campo la
     * lista ya está.
     */
    precargarValoresFiltro: function() {
      var self = this;
      // Se guarda la promesa, no solo se lanza: quien pinche un campo mientras está en vuelo tiene
      // que esperarla en vez de pedir ese campo por su cuenta, que es volver al recorrido del
      // reparto que esta pantalla acaba de quitar.
      if (self.precargaPromesa) return self.precargaPromesa;
      self.precargaPromesa = Oeb.getEjerciciosValoresFiltroTodos().then(function(res) {
        var dto = unwrapDto(res) || {};
        if (dto.buscarEnServidor) self.camposBusquedaServidor = dto.buscarEnServidor;
        var valores = dto.valores || {};
        Object.keys(valores).forEach(function(campo) {
          self.$set(self.valoresCache, campo, valores[campo] || []);
        });
      }).catch(function() {
        // Si falla, cada campo se sigue pudiendo pedir por su cuenta en abrirCampoFiltro: se
        // pierde la velocidad, no las opciones. El fallo se anota y la promesa se conserva
        // resuelta: olvidarla hacía que cada campo relanzara el lote y esperara a que volviera a
        // fallar antes de tirar del respaldo, sumando esa espera una vez por campo.
        self.precargaFallida = true;
      });
      return self.precargaPromesa;
    },
    // El reintento llega al volver a abrir la ventana, no antes: un corte de red no puede dejar la
    // pantalla pidiendo campo a campo el resto de la sesión, pero tampoco pagar el lote fallido en
    // cada clic de la apertura en la que ya falló.
    reintentarPrecargaSiFallo: function() {
      if (!this.precargaFallida) return;
      this.precargaFallida = false;
      this.precargaPromesa = null;
    },
    abrirCampoFiltro: function(campo) {
      var self = this;
      self.campoFiltroAbierto = campo;
      // Cualquier respuesta del campo anterior que llegue tarde ya no pinta nada.
      var secuencia = ++self.secuenciaCampoFiltro;
      self.cargandoFiltro = false;
      self.$set(self.errorFiltro, campo, '');
      if (!self.filtrosTemp[campo]) self.$set(self.filtrosTemp, campo, []);
      // $set y no asignación directa: en Vue 2 una clave nueva puesta a mano no es reactiva, y el
      // cuadro de búsqueda escribe justo aquí.
      if (typeof self.busquedaFiltro[campo] === 'undefined') self.$set(self.busquedaFiltro, campo, '');
      if (self.esBusquedaServidor(campo)) {
        // Un respiro pendiente de lo escrito antes ya no tiene a quién servir.
        if (self.busquedaServidorTimer) clearTimeout(self.busquedaServidorTimer);
        self.resultadosBusqueda = [];
        self.buscandoEnServidor = false;
        self.errorBusquedaServidor = false;
        self.lanzarBusquedaServidor(campo);
        return;
      }
      if (self.valoresCache[campo]) return; // ya cargado
      // #663 · El reloj atado a la sesión: si la sesión cambia en vuelo, la frontera calla el
      // `then` que lo apagaba, y la ruta conserva la instancia para la cuenta siguiente.
      cerrojoDeLaSesion(self, 'cargandoFiltro');
      // Con la precarga ya fallida en esta apertura, esperarla otra vez solo añade demora: al
      // respaldo directamente.
      if (self.precargaFallida) { self.cargarValoresCampo(campo, secuencia); return; }
      self.precargarValoresFiltro().then(function() {
        if (secuencia !== self.secuenciaCampoFiltro) return; // se pinchó otro campo mientras tanto
        // Si la precarga trajo el campo, ya está; solo se pide suelto cuando falló o cuando el
        // servidor no lo sirve en el lote.
        if (self.valoresCache[campo]) { self.cargandoFiltro = false; return; }
        return self.cargarValoresCampo(campo, secuencia);
      });
    },
    /** Respaldo por campo: la petición de siempre, para cuando la precarga no ha traído el campo. */
    cargarValoresCampo: function(campo, secuencia) {
      var self = this;
      return Oeb.getEjerciciosValoresFiltro(campo).then(function(res) {
        if (secuencia !== self.secuenciaCampoFiltro) return;
        self.$set(self.valoresCache, campo, unwrapDto(res) || []);
        self.$set(self.errorFiltro, campo, '');
        self.cargandoFiltro = false;
      }).catch(function() {
        if (secuencia !== self.secuenciaCampoFiltro) return;
        // Se anota el fallo en el campo en vez de dejarlo en blanco: una lista vacía y una lista
        // que no se ha podido traer se ven igual, y quien filtra necesita distinguirlas (#43).
        self.$set(self.errorFiltro, campo, 'No se ha podido cargar la lista.');
        self.cargandoFiltro = false;
      });
    },
    /** Vuelve a pedir la lista de un campo que falló, sin tener que cerrar y reabrir la ventana. */
    reintentarCampoFiltro: function(campo) {
      var self = this;
      if (!campo) return;
      self.$set(self.errorFiltro, campo, '');
      cerrojoDeLaSesion(self, 'cargandoFiltro');
      self.cargarValoresCampo(campo, ++self.secuenciaCampoFiltro);
    },
    // Los campos de lista se filtran en local sobre lo ya descargado; solo los de búsqueda en
    // servidor salen a preguntar, y con un respiro para no lanzar una petición por tecla.
    alEscribirEnFiltro: function(campo) {
      if (!this.esBusquedaServidor(campo)) return;
      var self = this;
      if (self.busquedaServidorTimer) clearTimeout(self.busquedaServidorTimer);
      // La tecla invalida ya lo que esté en vuelo, sin esperar al respiro: si la secuencia no
      // subiera hasta vencer los 300 ms, la respuesta de lo escrito antes pasaría la comprobación
      // y pintaría resultados del texto viejo —al borrar, incluso bajo el aviso de escribir dos
      // letras, y aún marcables—. Lo único que se difiere es la petición nueva.
      self.busquedaServidorSecuencia++;
      self.resultadosBusqueda = [];
      self.errorBusquedaServidor = false;
      var texto = (self.busquedaFiltro[campo] || '').trim();
      if (texto.length < self.minimoBusqueda) {
        self.buscandoEnServidor = false;
        return;
      }
      // El reloj se enciende ya, no al lanzar: así el hueco del respiro no enseña un "ningún
      // cliente coincide" de algo que todavía no se ha preguntado.
      self.buscandoEnServidor = true;
      self.busquedaServidorTimer = setTimeout(function() { self.lanzarBusquedaServidor(campo); }, 300);
    },
    lanzarBusquedaServidor: function(campo) {
      var self = this;
      var texto = (self.busquedaFiltro[campo] || '').trim();
      var secuencia = ++self.busquedaServidorSecuencia;
      if (texto.length < self.minimoBusqueda) {
        self.resultadosBusqueda = [];
        self.buscandoEnServidor = false;
        self.errorBusquedaServidor = false;
        return;
      }
      cerrojoDeLaSesion(self, 'buscandoEnServidor');
      self.errorBusquedaServidor = false;
      Oeb.buscarEjerciciosClientes(texto).then(function(res) {
        // Lo que conteste una búsqueda ya reemplazada no puede pisar a la que se está escribiendo.
        if (secuencia !== self.busquedaServidorSecuencia) return;
        var lista = unwrapDto(res) || [];
        self.recordarNombresCliente(lista);
        self.resultadosBusqueda = lista;
        self.buscandoEnServidor = false;
      }).catch(function() {
        if (secuencia !== self.busquedaServidorSecuencia) return;
        self.resultadosBusqueda = [];
        self.buscandoEnServidor = false;
        // "Ningún cliente coincide" sería mentira si lo que ha pasado es que no se ha podido
        // preguntar: el campo tiene que decir cuál de las dos cosas es (#43).
        self.errorBusquedaServidor = true;
      });
    },
    /** Repite la búsqueda de clientes que falló, con lo que siga escrito en el cuadro. */
    reintentarBusquedaServidor: function() {
      if (this.campoFiltroAbierto) this.lanzarBusquedaServidor(this.campoFiltroAbierto);
    },
    /**
     * Añade lo escrito al filtro como código de cliente (#43). Es la salida para los clientes que
     * están en el reparto pero ya no en el maestro: sin esto dejarían de poder filtrarse, y con la
     * lista de 200 de antes sí se podía. Se anota sin nombre porque no hay maestro que lo dé.
     */
    usarTextoComoCodigo: function() {
      var campo = this.campoFiltroAbierto;
      if (!campo || !this.pareceCodigoCliente) return;
      var codigo = this.textoBusquedaActual;
      var elegidos = this.filtrosTemp[campo] || [];
      if (elegidos.indexOf(codigo) === -1) this.$set(this.filtrosTemp, campo, elegidos.concat([codigo]));
      this.$set(this.nombresCliente, codigo, '');
      this.$set(this.busquedaFiltro, campo, '');
      // El cuadro queda vacío, así que lo que estuviera en vuelo tampoco puede pintar ya.
      if (this.busquedaServidorTimer) clearTimeout(this.busquedaServidorTimer);
      this.busquedaServidorSecuencia++;
      this.buscandoEnServidor = false;
      this.errorBusquedaServidor = false;
      this.resultadosBusqueda = [];
    },
    recordarNombresCliente: function(lista) {
      var self = this;
      lista.forEach(function(c) {
        if (c && c.codigo) self.$set(self.nombresCliente, c.codigo, c.nombre || '');
      });
    },
    // La ventana puede abrirse sobre una consulta guardada que ya traía clientes elegidos. Sin
    // esto se verían como códigos pelados y no habría forma de saber a quién se está filtrando.
    resolverNombresSeleccionados: function() {
      var self = this;
      var pendientes = [];
      self.camposBusquedaServidor.forEach(function(campo) {
        (self.filtrosTemp[campo] || []).forEach(function(codigo) {
          if (typeof self.nombresCliente[codigo] === 'undefined' && pendientes.indexOf(codigo) === -1) {
            pendientes.push(codigo);
          }
        });
      });
      if (!pendientes.length) return;
      Oeb.getEjerciciosClientesPorCodigo(pendientes).then(function(res) {
        self.recordarNombresCliente(unwrapDto(res) || []);
      }).catch(function() {});
    },
    consultar: function(recalcular, soloActual) {
      var self = this;
      cerrojoDeLaSesion(self, 'cargando');
      // #42 · Cada peticion lleva su numero y solo se pinta la ultima que se haya pedido. Pasar de
      // una consulta a otra dispara una peticion nueva sin cancelar la anterior, y la anterior
      // puede tardar mucho mas —si su combinacion de filtros no estaba en cache se rehacen veinte
      // anios—: al llegar tarde pintaba SUS cifras debajo de la etiqueta de la consulta nueva.
      var peticion = ++self.peticionEnCurso;
      var body = { anioDesde: 2007, anioHasta: self.anioActual };
      if (recalcular) body.recalcular = true;
      if (soloActual) body.soloAnioActual = true;
      var filtrosEnviar = {};
      var keys = Object.keys(self.filtrosActivos);
      for (var i = 0; i < keys.length; i++) {
        var k = keys[i];
        if (self.filtrosActivos[k] && self.filtrosActivos[k].length) filtrosEnviar[k] = self.filtrosActivos[k];
      }
      if (Object.keys(filtrosEnviar).length) body.filtros = filtrosEnviar;
      Oeb.getEjercicios(body).then(function(res) {
        if (peticion !== self.peticionEnCurso) return;
        var dto = unwrapDto(res) || res;
        self.ejercicios = dto.ejercicios || [];
        self.media = dto.media || { meses: [], total: 0 };
        self.mesesComparables = dto.mesesComparables || 0;
        self.aniosCacheados = dto.aniosCacheados || [];
        self.calculadoEn = dto.calculadoEn || null;
        self.cargando = false;
      }).catch(function() {
        // El fallo de una peticion vieja tampoco quita el preloader de la que sigue en marcha.
        if (peticion !== self.peticionEnCurso) return;
        self.cargando = false;
      });
    },
    cargarConsultasGuardadas: function() {
      var self = this;
      Oeb.getConsultas().then(function(res) {
        self.consultasGuardadas = unwrapDto(res) || [];
      }).catch(function() {});
    },
    abrirPopupFiltros: function() {
      // Copiar filtros activos a temp
      var temp = {};
      for (var i = 0; i < this.camposFiltro.length; i++) {
        var k = this.camposFiltro[i];
        temp[k] = this.filtrosActivos[k] ? this.filtrosActivos[k].slice() : [];
      }
      this.filtrosTemp = temp;
      this.campoFiltroAbierto = null;
      this.popupFiltros = true;
      this.reintentarPrecargaSiFallo();
      this.precargarValoresFiltro();
      this.resolverNombresSeleccionados();
    },
    seleccionarTodosFiltro: function(campo) {
      // En un campo que se busca escribiendo no hay "todos" que valga: lo que habría es el maestro
      // entero, que es justo lo que se ha dejado de descargar.
      if (this.esBusquedaServidor(campo)) return;
      this.$set(this.filtrosTemp, campo, (this.valoresCache[campo] || []).slice());
    },
    deseleccionarTodosFiltro: function(campo) {
      this.$set(this.filtrosTemp, campo, []);
    },
    aplicarFiltros: function() {
      var self = this;
      self.filtrosActivos = JSON.parse(JSON.stringify(self.filtrosTemp));
      self.popupFiltros = false;
      if (self.consultaEditando) {
        var config = { filtros: self.filtrosActivos, anios: self.aniosSeleccionados };
        Oeb.actualizarConsulta(self.consultaEditando.id, { filtros: config }).then(function() {
          self.$f7.toast.create({ text: 'Consulta actualizada', position: 'top', closeTimeout: 2000 }).open();
          self.consultaEditando = null;
          self.cargarConsultasGuardadas();
          self.consultar(false, true);
        });
      } else {
        self.consultaEditando = null;
        self.consultar(false, true);
      }
    },
    quitarFiltro: function(campo) {
      this.$set(this.filtrosActivos, campo, []);
      this.consultar(false, true);
    },
    guardarConsulta: function() {
      var self = this;
      self.$f7.dialog.prompt('Nombre de la consulta:', 'Guardar consulta', function(nombre) {
        if (!nombre || !nombre.trim()) return;
        var config = { filtros: self.filtrosActivos, anios: self.aniosSeleccionados };
        Oeb.crearConsulta({ nombre: nombre.trim(), filtros: config, compartida: false }).then(function(res) {
          var saved = unwrapDto(res);
          self.$f7.toast.create({ text: 'Consulta "' + nombre.trim() + '" guardada', position: 'top', closeTimeout: 2000 }).open();
          self.cargarConsultasGuardadas();
          if (saved && saved.id) {
            self.$f7.dialog.confirm('¿Compartir con otros usuarios?', 'Compartir', function() {
              self.compartirConsulta(saved);
            });
          }
        });
      });
    },
    compartirConsulta: function(consulta) {
      var self = this;
      self.$f7.dialog.prompt('Códigos de usuarios (separados por coma):', 'Compartir con', function(usuarios) {
        if (!usuarios || !usuarios.trim()) return;
        var lista = usuarios.split(',').map(function(u) { return u.trim(); }).filter(function(u) { return u; });
        Oeb.actualizarConsulta(consulta.id, { compartida: true, usuarios: lista }).then(function() {
          self.$f7.toast.create({ text: 'Compartida con ' + lista.join(', '), position: 'top', closeTimeout: 2000 }).open();
          self.cargarConsultasGuardadas();
        });
      });
    },
    cargarConsulta: function() {
      var self = this;
      if (!self.consultasGuardadas.length) {
        self.$f7.toast.create({ text: 'No hay consultas guardadas', position: 'top', closeTimeout: 1500 }).open();
        return;
      }
      var buttons = self.consultasGuardadas.map(function(c) {
        return { text: c.nombre + (c.compartida ? ' (compartida)' : ''), onClick: function() { self.aplicarConsulta(c); } };
      });
      buttons.push({ text: 'Cancelar', color: 'red' });
      self.$f7.actions.create({ buttons: [buttons] }).open();
    },
    aplicarConsulta: function(c) {
      var config = c.filtros || {};
      this.filtrosActivos = config.filtros || {};
      this.aniosSeleccionados = config.anios || [this.anioActual];
      this.consultaActiva = c.id;
      this.consultar(false, true);
    },
    borrarConsulta: function(consulta) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + consulta.nombre + '"?', 'Eliminar', function() {
        Oeb.eliminarConsulta(consulta.id).then(function() {
          self.consultasGuardadas = self.consultasGuardadas.filter(function(c) { return c.id !== consulta.id; });
          if (self.consultaActiva === consulta.id) self.consultaActiva = null;
          self.$f7.toast.create({ text: 'Consulta eliminada', position: 'top', closeTimeout: 2000 }).open();
        });
      });
    },
    // Drag & drop
    dragStartConsulta: function(e, idx) {
      this.draggingConsulta = idx;
      e.dataTransfer.effectAllowed = 'move';
    },
    dropConsulta: function(e, idx) {
      var from = this.draggingConsulta;
      if (from === null || from === idx) return;
      var item = this.consultasGuardadas.splice(from, 1)[0];
      this.consultasGuardadas.splice(idx, 0, item);
      this.draggingConsulta = null;
      var orden = this.consultasGuardadas.map(function(c) { return c.id; });
      Oeb.reordenarConsultas(orden);
    },
    // Menú contextual
    menuContextoConsulta: function(e, consulta) {
      this.menuConsulta = consulta;
      this.menuConsultaPos = { x: e.clientX, y: e.clientY };
      var self = this;
      setTimeout(function() {
        document.addEventListener('click', function handler() {
          self.menuConsulta = null;
          document.removeEventListener('click', handler);
        });
      }, 100);
    },
    editarFiltrosConsulta: function(consulta) {
      var self = this;
      self.menuConsulta = null;
      var config = consulta.filtros || {};
      var filtrosGuardados = config.filtros || {};
      self.filtrosTemp = {};
      self.camposFiltro.forEach(function(campo) {
        self.$set(self.filtrosTemp, campo, filtrosGuardados[campo] ? filtrosGuardados[campo].slice() : []);
      });
      self.consultaEditando = consulta;
      self.campoFiltroAbierto = null;
      self.popupFiltros = true;
      // Esta puerta a la ventana no pasa por abrirPopupFiltros, así que la precarga y los nombres
      // de los clientes ya elegidos hay que pedirlos aquí también.
      self.reintentarPrecargaSiFallo();
      self.precargarValoresFiltro();
      self.resolverNombresSeleccionados();
    },
    renombrarConsulta: function(consulta) {
      var self = this;
      self.menuConsulta = null;
      self.$f7.dialog.prompt('Nuevo nombre:', 'Renombrar', function(nombre) {
        if (!nombre || !nombre.trim()) return;
        Oeb.actualizarConsulta(consulta.id, { nombre: nombre.trim() }).then(function() {
          consulta.nombre = nombre.trim();
          self.$f7.toast.create({ text: 'Consulta renombrada', position: 'top', closeTimeout: 2000 }).open();
        });
      }, function() {}, consulta.nombre);
    },
    // Selección y compartir en lote
    toggleSeleccion: function(id) {
      var idx = this.consultasSeleccionadas.indexOf(id);
      if (idx > -1) this.consultasSeleccionadas.splice(idx, 1);
      else this.consultasSeleccionadas.push(id);
    },
    toggleModoSeleccion: function() {
      this.modoSeleccion = !this.modoSeleccion;
      if (!this.modoSeleccion) this.consultasSeleccionadas = [];
    },
    compartirEnLote: function() {
      var self = this;
      self.$f7.dialog.prompt('Códigos de usuarios (separados por coma):', 'Compartir con', function(usuarios) {
        var lista = usuarios.split(',').map(function(u) { return u.trim().toUpperCase(); }).filter(function(u) { return u; });
        if (!lista.length) return;
        var promises = self.consultasSeleccionadas.map(function(id) {
          return Oeb.actualizarConsulta(id, { compartida: true, usuarios: lista });
        });
        Promise.all(promises).then(function() {
          self.$f7.toast.create({ text: self.consultasSeleccionadas.length + ' consultas compartidas con ' + lista.join(', '), position: 'top', closeTimeout: 3000 }).open();
          self.modoSeleccion = false;
          self.consultasSeleccionadas = [];
          self.cargarConsultasGuardadas();
        });
      });
    },
    // Panel de ayuda
    togglePanelInfo: function() {
      var self = this;
      self.panelInfoAbierto = !self.panelInfoAbierto;
      if (self.panelInfoAbierto && self.instrucciones.length === 0) {
        Oeb.inicializarInstrucciones('ejercicios').then(function() {
          self.cargarInstrucciones();
        });
      }
    },
    cargarInstrucciones: function() {
      var self = this;
      Oeb.getInstrucciones('ejercicios').then(function(res) {
        self.instrucciones = (unwrapDto(res) || []).map(function(i) { i._editando = false; return i; });
      }).catch(function() {});
    },
    editarInstruccion: function(inst) { this.$set(inst, '_editando', true); },
    guardarInstruccion: function(inst) {
      var self = this;
      Oeb.actualizarInstruccion(inst.id, { titulo: inst.titulo, texto: inst.texto }).then(function() {
        inst._editando = false;
        self.$f7.toast.create({ text: 'Instrucción guardada', position: 'top', closeTimeout: 2000 }).open();
      });
    },
    eliminarInstruccion: function(inst) {
      var self = this;
      self.$f7.dialog.confirm('¿Eliminar "' + inst.titulo + '"?', 'Eliminar', function() {
        Oeb.eliminarInstruccion(inst.id).then(function() {
          self.instrucciones = self.instrucciones.filter(function(i) { return i.id !== inst.id; });
        });
      });
    },
    nuevaInstruccion: function() {
      var self = this;
      Oeb.crearInstruccion({ pantalla: 'ejercicios', titulo: 'Nueva instrucción', texto: 'Escribe aquí...', orden: self.instrucciones.length }).then(function(res) {
        if (unwrapDto(res)) { unwrapDto(res)._editando = true; self.instrucciones.push(unwrapDto(res)); }
      });
    },
    dragStartInst: function(e, idx) { this.draggingInst = idx; },
    dropInst: function(e, idx) {
      var from = this.draggingInst;
      if (from === null || from === idx) return;
      var item = this.instrucciones.splice(from, 1)[0];
      this.instrucciones.splice(idx, 0, item);
      this.draggingInst = null;
      var ids = this.instrucciones.map(function(i) { return i.id; });
      Oeb.reordenarInstrucciones(ids);
    },
    cambiarSelectorAnios: function() {
      var actual = this.anioActual;
      if (this.selectorAnios === 'actual') {
        this.aniosSeleccionados = [actual];
      } else if (this.selectorAnios === 'ultimos5') {
        this.aniosSeleccionados = [];
        for (var i = 0; i < 5; i++) this.aniosSeleccionados.push(actual - i);
      } else if (this.selectorAnios === 'ultimos10') {
        this.aniosSeleccionados = [];
        for (var i = 0; i < 10; i++) this.aniosSeleccionados.push(actual - i);
      } else if (this.selectorAnios === 'todos') {
        this.aniosSeleccionados = this.aniosDisponibles.slice();
      }
    },
    colorVar: function(v) { return v == null ? '' : (v >= 0 ? 'var-positivo' : 'var-negativo'); },
    formatImporte: function(valor) {
      if (valor == null || valor === 0) return '0';
      return Math.round(valor).toLocaleString('es-ES');
    },
    renderChart: function() {
      var self = this;
      if (!self.$refs.chartCanvas) return;
      if (typeof window.Chart === 'undefined') {
        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.js';
        script.onload = function() { self.renderChart(); };
        document.head.appendChild(script);
        return;
      }
      if (self.chartInstance) { self.chartInstance.destroy(); self.chartInstance = null; }
      var datos = self.ejerciciosFiltrados.slice().reverse();
      var labels = datos.map(function(e) { return e.anio; });
      var values = datos.map(function(e) { return e.total; });
      var colors = datos.map(function(e) { return e.anio === self.anioActual ? '#0F6E56' : '#185FA5'; });
      self.chartInstance = new window.Chart(self.$refs.chartCanvas, {
        type: 'bar',
        data: { labels: labels, datasets: [{ label: 'Total anual', data: values, backgroundColor: colors, borderRadius: 4 }] },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { callbacks: { label: function(ctx) { return ctx.parsed.y != null ? Math.round(ctx.parsed.y).toLocaleString('es-ES') + ' \u20AC' : ''; } } } },
          scales: { y: { ticks: { callback: function(val) { return (val / 1000000).toFixed(1) + 'M'; } } } }
        }
      });
    }
  }
};
</script>
